/* eslint-disable @typescript-eslint/naming-convention -- names are given by auto generated sdk */
// noinspection JSUnusedGlobalSymbols

import * as Sentry from '@sentry/react';
import { HttpClient, Me } from '@ydistri/identity-sdk';
import { getOAuthUrl } from '../helpers';
import { runInterceptor } from '@ydistri/utils';

export const IdentityAPI = new HttpClient({
  baseURL: getOAuthUrl(),
});

IdentityAPI.instance.interceptors.request.use(runInterceptor, error => {
  Sentry.captureException(error);
  const errorMessage = error instanceof Error ? error.message : String(error);
  return Promise.reject(new Error(errorMessage));
});

IdentityAPI.instance.interceptors.response.use(
  req => req,
  error => {
    /*
     When incorrect email is sent to "sendLinkForgetPasswordCreate", we get response in this format:

     {
       "Messages": [
          "Cannot find the user xxx@ydistri.com, because it does not exist."
       ]
     }

     */
    // The refusal stays whole - a form reads the problems off response.data - and its message is
    // the API's first flat message, which the sign-in screens show as they always did.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access  -- error is any from axios
    if (error.response?.data?.Messages) {
      return Promise.reject(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-assignment -- error.response.data.Messages is always an array
        Object.assign(new Error(error.response.data.Messages[0]), { response: error.response }),
      );
    }
    return Promise.reject(error instanceof Error ? error : new Error(String(error)));
  },
);

export const MeCollection = new Me(IdentityAPI);
